/** The amount of time to wait for the second click (double click) on an item. */
const DBL_CLICK_TIMEOUT = 301

/** The regex pattern for validating phone number inputs. */
const PHONE_INPUT_PATTERN = '^[0-9\\+\\-\\(\\) ]+$'

/** The regex pattern for validating email inputs. */
const EMAIL_INPUT_PATTERN = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$'

/** The regex pattern for validating website inputs. */
const WEBSITE_INPUT_PATTERN = '^((http|https)://)?[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}.*$'

/** The default regex pattern for validating inputs, allow any character. */
const DEFAULT_INPUT_PATTERN = '.*'

module.exports = {
    DBL_CLICK_TIMEOUT,
    PHONE_INPUT_PATTERN,
    EMAIL_INPUT_PATTERN,
    WEBSITE_INPUT_PATTERN,
    DEFAULT_INPUT_PATTERN
}